// extracted by mini-css-extract-plugin
module.exports = {"container":"_0da8c6f","message":"_f2d3355","buttons":"_e07e774"};